export const skymindTheme = {
    palette: {
        primary: {
            main: '#0B78A2',
            deepBlue: '#009CCF',
            buttonBlue: '#0C83B1',
            accentBlue: '#1aabff',
            primaryDark: '#0B78A2',
        },
        secondary: {
            lightGrey: '#c9c9c9',
            grey: '#7e7e7e',
            grey700: '#616161',
            skygrey: '#757575',
            borderGrey: '#E0E0E0',
            descriptionGrey: '#8f8f8f',
        },
        common: {
            font: "'Roboto', sans-serif",
            bullet: '#262626',
            white: '#ffffff',
            hintWhite: '#FAFAFA',
            black: '#000000',
            blackText: '#070707',
            linkColor: '#4fbbe4',
            previewTextColor: '#f9f9f9',
        },
    },
};

export const validaideTheme = {
    palette: {
        primary: {
            main: '#00A69C',
            deepBlue: '#008C83',
            buttonBlue: '#40BCB5',
            accentBlue: '#40BCB5',
            primaryDark: '#00A69C',
        },
        secondary: {
            lightGrey: '#c9c9c9',
            grey: '#7e7e7e',
            grey700: '#616161',
            skygrey: '#757575',
            borderGrey: '#E0E0E0',
            descriptionGrey: '#8f8f8f',
        },
        common: {
            font: "'Roboto', sans-serif",
            bullet: '#262626',
            white: '#ffffff',
            hintWhite: '#FAFAFA',
            black: '#000000',
            blackText: '#070707',
            linkColor: '#4fbbe4',
            previewTextColor: '#f9f9f9',
        },
    },
};
